import React, { useEffect, useState } from "react";
import Modal from "../../../../Component/modal/Modal";
import { addOfferToUserProfile, checkUserOfferStatus } from "../../../../API/ApiService";
import { toast } from "react-toastify";
import { Loader } from "../../../Loader/Loader";
import { ComponentLoader } from "../../../../Component/ComponentLoader";
import moment from "moment/moment";

const OfferPopup = ({ selectedOffer, handleClose, setClaimOffer, isLoggedIn, setIsLoginModal }) => {
  const [loading, setLoading] = useState(false);
  const [changeBtn, setChangeBtn] = useState(false);

  console.log(selectedOffer);

  const user_uuid = localStorage.getItem("user_uuid");
  useEffect(() => {
    if (isLoggedIn) {
      checkOfferStatus()
    }
  }, [isLoggedIn]);

  const HOW_TO_USE_IT = [
    "Click on the \"Add to my Offer\" button to save the offer to My Offers in your account.",
    "Use the map navigation provided in the business detail within the app to reach the business location. Show this offer to the Business Owner.",
    "Present the Offer QR code for the business owner to scan and apply to your purchase."
  ]
  const checkOfferStatus = () => {
    setLoading(true);
    let body = {
      "offer_id": selectedOffer.id
    }
    checkUserOfferStatus(body).then((res) => {
      setChangeBtn(res?.data?.result);
      setLoading(false);
    })
      .catch((error) => {
        setLoading(false);
      })
  }

  const handleAddToMyOffer = () => {
    if (!isLoggedIn) {
      handleClose()
      setIsLoginModal(true)
      return
    }
    const data = {
      status: 0,
      offer_id: selectedOffer.id,
      user_uuid: user_uuid
    }

    addOfferToUserProfile(data).then((res) => {
      console.log(res, "OFFER_ADDED");
      if (res.data.status === 200) {
        handleClose()
        toast.success('Offer Added to My Offer successfully')
      }
    })
  }

  const handleClaimNow = () => {
    if (!isLoggedIn) {
      handleClose()
      setIsLoginModal(true)
      return
    }
    if (changeBtn) {
      setClaimOffer(selectedOffer)
      handleClose()
    } else {
      const data = {
        status: 0,
        offer_id: selectedOffer.id,
        user_uuid: user_uuid
      }

      addOfferToUserProfile(data).then((res) => {
        console.log(res, "OFFER_ADDED");
        if (res.data.status === 200) {
          setClaimOffer(selectedOffer)
          handleClose()
          toast.success('Offer Added to My Offer successfully')
        }
      })
    }
  }

  return (
    <Modal
      isOpen={true}
      onClose={() => handleClose()}
    >
      {loading && <ComponentLoader />}
      <div className="sale-popContent-container">
        <div className="modal-event-box-img">
          <img
            src={
              selectedOffer?.offerImage &&
                selectedOffer?.offerImage.length > 0
                ? selectedOffer?.offerImage[0].image
                : "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
            }
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: "15px",
            }}
          />
        </div>
        <h5 className="saleTitle">{selectedOffer?.title}</h5>
        <p style={{ color: "#3CA059", fontSize: "18px", fontWeight: "400" }}>
          {selectedOffer?.tag_line}
        </p>
        <span
          style={{
            color: "#FCFCFC",
            fontSize: "16px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            paddingBottom: "12px",
          }}
        >
          <img src="/images/calender.svg" width={16} />
          <span>{moment(selectedOffer?.start_date).format('Do MMM YYYY')} </span> -{" "}
          <span>{moment(selectedOffer?.end_date).format('Do MMM YYYY')} </span>
        </span>
        <div style={{ marginTop: '20px' }}>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>
            Offers
          </h3>
          {selectedOffer?.description?.map((des, index) => {
            return (
              <ol
                key={index}
                style={{ listStyle: "outside", marginBottom: '10px', paddingLeft: "20px" }}
              >
                <li
                  style={{ fontSize: "14px", fontWeight: "600", color: "#fff" }}
                >
                  <span style={{ fontWeight: "400", color: "#9f9f9f" }}>
                    {des.value}
                  </span>
                </li>
              </ol>
            );
          })}
        </div>
        <div style={{ margin: '30px 0' }}>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>
            How to use it
          </h3>
          {HOW_TO_USE_IT?.map((des, index) => {
            return (
              <ol
                key={index}
                style={{ listStyle: "outside", paddingLeft: "20px" }}
              >
                <li
                  style={{ fontSize: "14px", fontWeight: "600", color: "#fff" }}
                >
                  Step {index + 1} -{" "}
                  <span style={{ fontWeight: "400", color: "#9f9f9f" }}>
                    {des}
                  </span>
                </li>
              </ol>
            );
          })}
        </div>

        <h6 style={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}>
          Terms & Conditions{" "}
        </h6>
        {selectedOffer?.term_conditions?.map((terms, id) => {
          return (
            <ol key={id} style={{ listStyle: "outside", paddingLeft: "20px" }}>
              <li
                style={{
                  color: "#9f9f9f",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {terms.value}
              </li>
            </ol>
          );
        })}

        {loading ? <Loader /> : <div style={{ display: 'flex', justifyContent: 'center', gap: 20, padding: '30px 0' }}>
          {!changeBtn && <button className="business-telBtn" onClick={handleAddToMyOffer}>
            Add To My Offer
          </button>}
          {isLoggedIn && <button className="business-telBtn" onClick={handleClaimNow}>
            Claim Now
          </button>}
        </div>}
      </div>
    </Modal>
  );
};

export default OfferPopup;
